import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';

export default function useFormContactSchema() {
  const { t } = useTranslation();
  return z.object({
    firstName: z
      .string()
      .min(2, t('form.contact.firstName.error'))
      .max(30, t('form.contact.firstName.error')),
    lastName: z
      .string()
      .min(2, t('form.contact.lastName.error'))
      .max(30, t('form.contact.lastName.error')),
    email: z.string().email(t('form.contact.email.error')),
    phone: z.string().refine(
      (value) => {
        if (!value || !isValidPhoneNumber(value)) {
          return false;
        }
        return true;
      },
      {
        message: t('form.contact.phone.error'),
      }
    ),
  });
}

export type FormContactSchema = z.infer<
  ReturnType<typeof useFormContactSchema>
>;
